import React from "react";

/**
 * @component CloseSmallIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <CloseSmallIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const CloseSmallIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="CloseSmallIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        d="M9.485 8.071l2.828 2.827 2.83-2.827a1 1 0 011.413 1.414l-2.828 2.828 2.828 2.83a1 1 0 01-1.414 1.413l-2.829-2.828-2.828 2.828a1 1 0 11-1.414-1.414l2.827-2.829-2.827-2.828a1 1 0 011.414-1.414z"
        fillRule="evenodd"
      />
    </svg>
  )
);
CloseSmallIcon.displayName = "CloseSmallIcon";
export default CloseSmallIcon;
